import { GetStaticPaths } from 'next'
import { PillarPage } from 'src/constants/searchPages'
import { PostOrderByInput } from 'src/types/hygraph'
import { getPosts, PILLAR_BLOG_TOPIC } from 'src/utils/hygraph'
import Page, { BLOG_PAGE_SIZE, getStaticProps } from '../../../blog/index'

export default Page

export const getStaticPaths: GetStaticPaths = async ({ locales = [] }) => {
  const paths: {
    params: { pillar: PillarPage; page: string }
    locale: string
  }[] = await Promise.all(
    locales.flatMap((locale) =>
      Object.values(PillarPage).map(async (pillar) => {
        const topic = PILLAR_BLOG_TOPIC[pillar]
        const res = await getPosts(1000, 0, PostOrderByInput.PublishedAtDesc, {
          topic,
          listOnly: true
        })
        const count = res.data?.postsConnection?.aggregate?.count ?? 0
        const pages = Math.ceil(count / BLOG_PAGE_SIZE)

        return Array.from({ length: pages - 1 }, (_, i) => ({
          params: { pillar, page: (i + 2).toString() },
          locale
        }))
      })
    )
  ).then((nestedArrays) => nestedArrays.flat())

  return { paths: paths, fallback: false }
}

export { getStaticProps }
